import { OnboardingProTask } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/onboarding.pb';
import { useNavigate } from '@frontend/weave-router';
import { CALL_INTEL_PATH } from '../constant';
import { useProOnboardingActionShallowStore } from '../hooks/use-pro-onboarding-action-store';
import type { TaskAction, TaskActionArgs } from '../types';

export function useProViewPatientContextAction({ onClose }: TaskActionArgs): TaskAction {
  const navigate = useNavigate();

  const { setPendingTask } = useProOnboardingActionShallowStore('setPendingTask');

  return {
    isEnabled: true,
    isLoading: false,
    onSelect: () => {
      setPendingTask(OnboardingProTask.PRO_TASK_VIEW_PATIENT_CONTEXT);
      navigate({ to: CALL_INTEL_PATH });
      onClose();
    },
  };
}
